import { CtaButton } from "../Buttons";
import React from "react";
import { getTranslations } from "../../Common/utils";

const BackSection = ({ backButtonClick = () => {}, hasRhsSection = false, rhsSection = null }) => {
  return (
    <div className='si-backSection-wrapper'>
      <div className='si-main__container si-backSection'>
        <CtaButton 
          onlyIcon={true} 
          variant='ghost' 
          icon={'f1i-ar-left'} 
          onClick={backButtonClick}
        >
          {getTranslations('cta_back', 'Back')}
        </CtaButton>
        {hasRhsSection && <div className='si-backSection-rhs'>{rhsSection}</div>}
      </div>
    </div>
  );
};

export default BackSection;

